import React, {Component} from 'react';
import GoBackButton from './GoBackButton'
import {getText} from './util/localization.js'
import {setProperties} from "./util/DefaultProperties";

const localization = require('../localization/localization-notFound.json');
const queryString = require('query-string');


class NotFound extends Component {

    constructor(props){
        super(props);

        let queryStringParams = queryString.parse(props.location.search);
        setProperties(queryStringParams);
    }

    render() {
        return (<div className="container">
            <h1>{getText(localization.title)}</h1>
            <p className="alert alert-danger">{getText(localization.alertText)}</p>
            <GoBackButton {...this.props}/>
        </div>);
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/js/NotFound.js